import { EnvironmentConfig } from './interface'

const buildEnvConfig = (env: string, apiKey: string, inboxUrl?: string): EnvironmentConfig => {
  const serviceInt = env !== 'prod' ? '-int' : ''
  const isDev = env === 'dev' ? 'dev/' : ''
  return {
    api: {
      endpointsBaseURL: {
        amap: `https://services-amap.me${serviceInt}.mercedes-benz.com/reach-me/${isDev}api/msg/v1/consumer`,
        china: `https://services-china.me${serviceInt}.mercedes-benz.com/reach-me/${isDev}api/msg/v1/consumer`,
        emea: `https://services.me${serviceInt}.mercedes-benz.com/reach-me/${isDev}api/msg/v1/consumer`,
      },
      apiKey,
    },
  }
}

const config: Record<string, EnvironmentConfig> = {
  test: buildEnvConfig('test', 'd9761fc2-3ad9-46ab-b172-36be136c56f6'),
  dev: buildEnvConfig('dev', '8c742568-a013-41b0-86eb-5b1bd521c24b'),
  int: buildEnvConfig('int', 'd9761fc2-3ad9-46ab-b172-36be136c56f6'),
  pprod: buildEnvConfig('pprod', 'd9761fc2-3ad9-46ab-b172-36be136c56f6'),
  prod: buildEnvConfig('prod', '6afdf6b2-929f-450f-95fb-61fa965f430d'),
}

export default config
